import { render, staticRenderFns } from "./CandidateIndex.vue?vue&type=template&id=807db824&scoped=true"
import script from "./CandidateIndex.vue?vue&type=script&lang=ts"
export * from "./CandidateIndex.vue?vue&type=script&lang=ts"
import style0 from "./CandidateIndex.vue?vue&type=style&index=0&id=807db824&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807db824",
  null
  
)

export default component.exports